<template>
  <v-tooltip right :color="tooltipColor || siteColors.primary" max-width="300">
    <template v-slot:activator="{ on }">
      <v-btn
        class="table-info-btn"
        text
        icon
        small
        :color="buttonColor || siteColors.primary"
        v-on="on"
      >
        <v-icon>mdi-information</v-icon>
      </v-btn>
    </template>
    <span>
      {{ info }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    info: {
      type: String,
      default: ""
    },
    tooltipColor: {
      type: String,
      default: undefined
    },
    buttonColor: {
      type: String,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn.table-info-btn {
  margin-left: auto;
  margin-right: -10px;
}

.v-tooltip__content {
  opacity: 1 !important;
}
</style>
